"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bluebird_1 = __importDefault(require("bluebird"));
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const constants_1 = require("@powerednow/shared/constants");
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
// eslint-disable-next-line no-redeclare
class Payment extends complexData_1.default {
    async setNoSync() {
        if (this.data.accounting_reference?.length > 0) {
            return;
        }
        this.data.accounting_reference = constants_1.INTEGRATION.ACCOUNTING_REFERENCE_NO_SYNC;
    }
    async resetNoSync() {
        if (this.data.accounting_reference !== constants_1.INTEGRATION.ACCOUNTING_REFERENCE_NO_SYNC) {
            return;
        }
        this.data.accounting_reference = null;
    }
    static get allowedAssociations() {
        return {
            company: {
                instance: (0, modelLookup_1.complexFindModel)('Company'),
                key: 'company',
                single: true,
                cascadeDelete: false,
                condition: {
                    id: Payment.Entity.getForeignFieldSymbols().company_id,
                },
            },
            paymentToInvoice: {
                key: 'paymentToInvoice',
                instance: (0, modelLookup_1.complexFindModel)('PaymentToInvoice'),
                single: true,
                cascadeDelete: false,
                condition: {
                    payment_id: Payment.Entity.getFieldSymbols().id,
                },
            },
            paymentType: {
                key: 'paymentType',
                instance: (0, modelLookup_1.complexFindModel)('PaymentType'),
                single: true,
                condition: {
                    id: Payment.Entity.getForeignFieldSymbols().type,
                },
            },
            cisPayment: {
                key: 'payment',
                instance: (0, modelLookup_1.complexFindModel)('Payment'),
                single: true,
                cascadeDelete: false,
                condition: {
                    id: Payment.Entity.getForeignFieldSymbols().cis_payment_id,
                },
            },
        };
    }
    static get indexedSearchConfig() {
        return {
            paymentToInvoice: true,
            paymentType: true,
        };
    }
    async getDocument() {
        const paymentToInvoice = await this.getPaymentToInvoice();
        return paymentToInvoice.getDocument();
    }
    async getCustomer() {
        const document = await this.getDocument();
        return document.getCustomer();
    }
    async getDefaultSite() {
        const document = await this.getDocument();
        return document.getDefaultSite();
    }
    // @TODO the two functions below are not really working if the related complex document instance is not created
    async getPaymentsOfSameType() {
        const parentDocument = await this.getDocument();
        const siblingPayments = await parentDocument.getPayments();
        return siblingPayments.filter(payment => payment.data.type === this.data.type);
    }
    async hasMatchingRefund() {
        const sameTypePayments = await this.getPaymentsOfSameType();
        return sameTypePayments.some(payment => payment.data.is_refund && payment.data.reference === this.data.reference);
    }
    /**
     * Function used to emit data for the complex data proxy used in receivePaymentViewController
     *
     * @param document
     * @param isRefund
     */
    async getAllAvailablePaymentsForDocumentType(document, isRefund) {
        return bluebird_1.default.filter((0, modelLookup_1.complexFindModel)('PaymentType').getAll(this), async (paymentType) => {
            //
            // If this is the passed in then no further check needed
            //
            if (this.data.id === paymentType.data.id) {
                return true;
            }
            //
            // If not selectable by type then nothing to do here
            //
            if (!paymentType.data.selectable) {
                return false;
            }
            return document.paymentCanBeRecorded(paymentType.data.id, isRefund);
        })
            .then(paymentTypes => paymentTypes.sort((a, b) => (a.data.sequence <= b.data.sequence ? -1 : 1)));
    }
    async getMessageTemplateData(messageType) {
        const documentData = await this.getDocument();
        return { ...this.data.getPureDataValues(), document: documentData.data.getPureDataValues() };
    }
    async getPermanentTemplateData() {
        return {};
    }
}
Payment.Entity = entity_1.default;
Payment.modelProperties = modelProperties_1.default;
Payment.MessageTypeSpecificDataCollectors = {};
Payment.MessageTypeSpecificPermanentDataCollectors = {};
exports.default = Payment;
//# sourceMappingURL=../../../../src/models/payment/index.js.map